export default [
  {
    category: 'Australian Taxation',
    list: [
      { label: 'Corporation and Trust' },
      { label: 'Property and Investments' },
      { label: 'GST' },
      { label: 'Cryptocurrency Tax' },
      { label: 'Anti-Avoidance and Risk Assessment' },
      { label: 'Off-Shore Financing' },
      { label: 'Financial Reporting and Accounting' },
      { label: 'Payroll Obligations' },
      { label: 'Advanced Tax Planning' },
    ],
  },
  {
    category: 'Business Finance and Valuation',
    list: [
      { label: 'Valuation and Forecast' },
      { label: 'Capital and Ownership Structure' },
      { label: 'Financial Modeling' },

    ],
  },
  {
    category: 'Business Strategy',
    list: [
      { label: 'Business and Risk Analysis' },
      { label: 'Systems and Value Driver' },
      { label: 'Process Improvement' },
      { label: 'Trends and Statistical Modeling' },
    ],
  },
  {
    category: 'Other',
    list: [
      { label: 'Business Life Cycle (Liquidation, Debt and Recovery Advise)' },
      { label: 'Marketing and Media Engagement' },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/consts/skills.js